import React from 'react';

import { Button, Icons } from '@components/common';
import CategoriesList from '@components/common/CategoriesList';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { categoriesFormatted } from '@utils/formatter';
import { openWebsite } from '@utils/openWebsiteHelper';
import { formatPhoneNumber } from '@utils/phoneUtils';

import styles from './Summary.module.scss';

interface ISummaryProps {
	profile: Record<string, any>;
	toggleOrganisationModal: () => void;
}

const Summary = ({
	profile,
	toggleOrganisationModal,
}: ISummaryProps) => {
	const {
		accessPermission: {
			platformOwnerAdministrator,
			assetOwnerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			assetConsumerOrganizationAdministrator,
		},
	} = useAppSelector(auth);
	const categories = categoriesFormatted(profile?.categories);
	const isEditAccess = (
		platformOwnerAdministrator
		|| assetOwnerOrganizationAdministrator
		|| networkOperatorOrganizationAdministrator
		|| assetConsumerOrganizationAdministrator
	);

	const openOrganisationWebsite = () => openWebsite(profile?.websiteURL);

	const address = [
		profile?.nameProperty,
		profile?.streetName,
		profile?.locality,
		profile?.city,
		profile?.postcode,
	].filter(item => !!item).join(', ');

	return (
		<div className={styles.summaryContainer}>
			<div className={styles.contactSection}>
				<div>
					{Icons.locationIcon()}
					{address}
				</div>
				{!!profile?.email
					&& <div>
						{Icons.emailIcon()}
						{profile.email}
					</div>
				}
				{!!profile?.phoneNumber
					&& <div>
						{Icons.phoneIcon()}
						{formatPhoneNumber(profile.phoneNumber)}
					</div>
				}
			</div>
			<div>
				<div className={styles.aboutSection}>
					{!!profile?.legalName
						&& <>
							<div>Legal Name</div>
							<div>{profile.legalName}</div>
						</>
					}
					{!!profile?.websiteURL
						&& <>
							<div>Website URL</div>
							<div>
								<div
									className={styles.link}
									onClick={openOrganisationWebsite}
								>
									{profile.websiteURL}
								</div>
							</div>
						</>
					}
					{!!profile?.companyRegistrationNumber
						&& <>
							<div>CRN</div>
							<div>{profile.companyRegistrationNumber}</div>
						</>
					}
					{!!categories
						&& <>
							<div>Categories</div>
							<CategoriesList categories={categories} />
						</>
					}
					{!!profile?.organizationTelecomId
						&& <>
							<div>Organisation Telecom ID</div>
							<div>{profile.organizationTelecomId}</div>
						</>
					}
				</div>
				<div className={styles.summaryButtons}>
					{isEditAccess
						&& <Button
							onClick={toggleOrganisationModal}
							text='Edit'
						/>
					}
				</div>
			</div>
		</div>
	);
};

export default Summary;
